/*
  custom-search-close-animation.js
  CLAUDE THEME: give the header search overlay an animated EXIT to match its entrance.

  The overlay is a Shrine <details-modal>: opening sets [open] on the inner <details>, so
  the CSS entrance transition runs; but DetailsModal.close() removes [open] immediately,
  and a <details> stops rendering its content the same frame - no exit transition can
  ever play. The cart/menu drawers animate out because they toggle a class instead.

  Fix without touching Shrine: wrap DetailsModal.prototype.close for the search modal
  only. Add `search-exiting` (custom-search-drawer.css returns the card + backdrop to
  their pre-open pose, so the entrance simply plays backwards), keep [open] until that
  transition finishes, then run Shrine's original close (focus, body scroll-lock, etc).
*/
(function () {
  'use strict';

  var EXIT_MS = 300; /* matches the card's 0.3s open transition in custom-search-drawer.css */

  customElements.whenDefined('details-modal').then(function () {
    var proto = customElements.get('details-modal').prototype;
    var originalClose = proto.close;

    proto.close = function (focusToggle) {
      var details = this.detailsContainer;
      /* Animate only the header search overlay; any other details-modal keeps Shrine's
         instant close. A second close() while exiting falls through to the original,
         which just ends the animation early and is idempotent. */
      if (
        !this.closest('.header__search') ||
        !details ||
        !details.hasAttribute('open') ||
        details.classList.contains('search-exiting')
      ) {
        return originalClose.call(this, focusToggle);
      }
      var self = this;
      details.classList.add('search-exiting');
      /* Unfreeze the page NOW, behind the still-visible fading card. Unlocking fires a
         chain of heavy work - the scroll-lock restores the scroll position, that scroll
         re-runs the sticky dock->pill morph (a header HEIGHT change: the "page nudges up"),
         and the scroll-idle helper toggles the header blur off/on. Done at the END of the
         fade all of that stuttered in the open air; done here the card masks it, and the
         backdrop-filter (still suppressed until [open] drops) returns once, onto a header
         that has already settled. Shrine's close() removes the class again - idempotent. */
      document.body.classList.remove('overflow-hidden');
      setTimeout(function () {
        originalClose.call(self, focusToggle);
        details.classList.remove('search-exiting');
        /* if a drawer (e.g. the cart) opened during the fade and re-locked the page,
           Shrine's close just stripped that fresh lock - hand it back */
        if (document.querySelector('cart-drawer.active, details[open] .menu-drawer')) {
          document.body.classList.add('overflow-hidden');
        }
      }, EXIT_MS);
    };
  });

  /* The X button is wired in Shrine's constructor with `this.close.bind(this)`; bind
     snapshots the ORIGINAL close at element upgrade, before the prototype patch above
     exists, so clicks on the X still closed instantly (Escape/overlay/summary call
     this.close() dynamically and get the patch). Intercept the click in the CAPTURE
     phase - it runs before the button's own listener - and route it through the
     patched close instead. */
  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest('.header__search .search-modal__close-button');
      if (!btn) return;
      var modal = btn.closest('details-modal');
      if (!modal || typeof modal.close !== 'function') return;
      event.stopPropagation(); /* the bound original-close listener never fires */
      modal.close();
    },
    true
  );
})();
/* cache-bust 2026-07-23 */
